<template>
  <div>
    <v-app>
      <div v-if="!userid && order">
        <v-container>
          <v-alert :value="true" color="warning" icon="priority_high" outline>
            {{ $t("Not found this page") }}
          </v-alert>
        </v-container>
      </div>
      <div v-if="userid && order">
        <merchant-detail v-model="pageProfile"></merchant-detail>
        <v-container class="mt-5">
          <template v-if="pageLoading">
            <div class="text-xs-center my-3">
              <v-progress-circular
                :key="theme.color"
                indeterminate
                :color="theme.color"
              ></v-progress-circular>
            </div>
          </template>
          <template v-else>
            <!-- {{ order }} -->

            <div class="text-xs-center">
              <img
                src="@/assets/img/ecommerce/success.png"
                v-if="gbResponse && gbResponse.resultCode == '00' && order.status == 'paid'"
                style="max-width: 150px"
              />
              <img
                src="@/assets/img/ecommerce/error.png"
                v-else-if="(gbResponse && gbResponse.resultCode != '00') || order.status != 'paid'"
                style="max-width: 150px"
              />
              <div class="mb-4">
                <div
                  class="headline"
                  :class="{
                    'success--text': gbResponse.resultCode == '00',
                    'error--text': gbResponse.resultCode != '00',
                  }"
                >
                  {{ current_gb_desc.meaning }}
                </div>
                <div class="caption">{{ current_gb_desc.recommendation }}</div>
              </div>
            </div>
            <table class="mx-auto" style="width: 100%; max-width: 300px">
              <tr>
                <td class="font-weight-bold py-1">Order No</td>
                <td class="text-xs-right py-1">
                  {{ order.id }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold py-1">GB Reference No</td>
                <td class="text-xs-right py-1">
                  {{ order.transactionid }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold py-1">{{ $t("Total") }}</td>
                <td class="text-xs-right py-1">
                  {{ order.total }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold py-1">refid</td>
                <td class="text-xs-right py-1">
                  {{ order.refid }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold py-1">{{ $t("Total") }}</td>
                <td class="text-xs-right py-1">
                  {{ order.total }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold py-1">Time</td>
                <td class="text-xs-right py-1">
                  {{ order.timestamp | DateFormat("DD MMM YYYY HH:mm a") }}
                </td>
              </tr>
            </table>
          </template>
        </v-container>
      </div>
    </v-app>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/config";
import axios from "axios";
import MerchantDetail from "@/components/ecommerce/MerchantDetail.vue";
//https://shopv2.zwiz.ai/creditgbprime?userid=1421782574607927&pageid=998122266996445&referenceNo=778837624
export default {
  data() {
    return {
      userid: null,
      sessiontoken: null,
      pageLoading: true,
      loading: true,
      pageid: null,
      refno: null,
      order: null,
      gbResponse: null,
      status: null,
      gbprime_desc: [
        { resultCode: "00", meaning: "Approved", recommendation: "Payment Completed" },
        {
          resultCode: "01",
          meaning: "Refer to Card Issuer",
          recommendation: "Give cardholder contacts issuer bank",
        },
        {
          resultCode: "03",
          meaning: "Invalid Merchant ID",
          recommendation: "Please contact GBPrimePay",
        },
        {
          resultCode: "05",
          meaning: "Do Not Honour",
          recommendation:
            "Cardholder input invalid card information. Ex. Expiry date, CVV2 or card number. Give cardholder contacts issuer bank.",
        },
        {
          resultCode: "12",
          meaning: "Invalid Transaction",
          recommendation: "Please contact GBPrimePay",
        },
        {
          resultCode: "13",
          meaning: "Invalid Amount",
          recommendation: "Payment amount must more than 0.1",
        },
        {
          resultCode: "14",
          meaning: "Invalid Card Number",
          recommendation: "Please check all digits of card no.",
        },
        {
          resultCode: "17",
          meaning: "Customer Cancellation",
          recommendation:
            "Customers click at cancel button in payment page when they make transaction. Customers have to make new payment transaction.",
        },
        {
          resultCode: "19",
          meaning: "Re-enter Transaction",
          recommendation: "Duplicate payment. Please contact GBPrimePay",
        },
        {
          resultCode: "30",
          meaning: "Format Error",
          recommendation: "Transaction format error. Please contact GBPrimePay",
        },
        {
          resultCode: "41",
          meaning: "Lost Card -Pick Up",
          recommendation: "Lost Card and Cardholder give up.",
        },
        {
          resultCode: "43",
          meaning: "Stolen Card -Pick Up",
          recommendation: "Stolen Card and Cardholder give up.",
        },
        {
          resultCode: "50",
          meaning: "Invalid Payment Condition",
          recommendation:
            "Ex. Session time out or invalid VbV Password : ask cardholders to try ma again and complete transaction within 15 minutes with correct card information.",
        },
        {
          resultCode: "51",
          meaning: "Insufficient Funds",
          recommendation: "Not enough credit limit to pay. Please contact issuer",
        },
        {
          resultCode: "54",
          meaning: "Expired Card",
          recommendation: "Cardholder key in invalid expiry date",
        },
        { resultCode: "55", meaning: "Wrong Pin", recommendation: "Wrong Pin" },
        {
          resultCode: "58",
          meaning: "Transaction not Permitted to Terminal",
          recommendation:
            "Issuer does not allow to pay with debit card (Visa Electron, Mastercard Electron)",
        },
        {
          resultCode: "91",
          meaning: "Issuer or Switch is Inoperative",
          recommendation: "Issuer system is not available to authorize payment",
        },
        {
          resultCode: "94",
          meaning: "Duplicate Transmission",
          recommendation: "Please inform GBPrimePay to investigate",
        },
        {
          resultCode: "96",
          meaning: "System Malfunction",
          recommendation: "Issuer bank system can not give a service",
        },
        {
          resultCode: "xx",
          meaning: "Transaction Timeout",
          recommendation: "Can not receive response code from issuer with in the time limit",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentLang: "currentLang",
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
      theme: "getTheme",
    }),
    current_gb_desc() {
      if (!this.gbResponse)
        return {
          resultCode: null,
          meaning: "loading",
          recommendation: "",
        };
      var desc = this.gbprime_desc.find((el) => {
        return el.resultCode == this.gbResponse.resultCode;
      });
      if (desc) return desc;
      else
        return {
          resultCode: null,
          meaning: "",
          recommendation: "",
        };
    },
    pagename: function() {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined;
    },
  },
  components: {
    MerchantDetail,
  },
  async mounted() {
    this.$validator.localize(this.currentLang);

    this.loading = true;

    if (this.$route.query.userid) {
      this.userid = this.$route.query.userid;
    }

    if (this.$route.query.sessiontoken) {
      this.sessiontoken = this.$route.query.sessiontoken;
    }
    await this.$store.dispatch("loadPageProfile", this.pagename);

    this.pageLoading = true;

    this.pageid = this.pageProfile.pageid;

    document.title = this.pageProfile.pagename;
    this.$store.dispatch("updateShopColor", this.pageProfile.shopcolor);
    if (this.$route.query.referenceNo) {
      this.refno = this.$route.query.referenceNo;
      this.order = await this.gbprimeorderwithrefno();
      try {
        var json = JSON.parse(this.order.jsonvalue);
        if (json && json.gbResponse) this.gbResponse = json.gbResponse;
      } catch (error) {
        //
      }
    }
    this.pageLoading = false;
  },
  methods: {
    async gbprimeorderwithrefno() {
      var data = {
        pageid: this.pageProfile.pageid,
        userid: this.userid,
        refno: this.refno,
      };
      var response = await axios.get(config.getConfig("serverUrl") + "gbprimeorderwithrefno", {
        params: data,
      });

      if (
        response.status == 200 &&
        response.data.responsecode == 200 &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        return response.data.data[0];
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
